import course_1 from "../../assets/course/course-1.png";
import course_2 from "../../assets/course/course-2.png";
const arrDataCourse = [
    {
        id: 1,
        name: "FRONTEND NEWBIE",
        desc: "Khóa học phù hợp cho các bạn mới tiếp xúc với web và Frontend cũng như các bạn cần nâng cao kiến thức Frontend",
        time: "40 buổi",
        price_offline: "11.000.000 VNĐ",
        price_online: "9.500.000 VNĐ",
        price_tragop: "2.900.000 VNĐ",
        img: course_1,
        timeline: [
            {
                id: 1,
                title: "HTML/CSS",
                time: "10 buổi",
                lyThuyet: [
                    "Các kiến thức cơ bản của web",
                    "Các thẻ HTML và cách áp dụng thực tế",
                    "Các thuộc tính CSS và bài áp dụng tương ứng",
                    "CÁCH ĐẶT TÊN CLASS + VIẾT CLEAN CODE HTML / CSS",
                    "RESPONSOVE trên mobile và ipad",
                    "ANIMATION hover & keyframe",
                ],
                baiTap: ["Profile facebook", "Form login", "Header", "Footer", "List Product", "Animation loading"],
                toTal: ["30+ Mini Project", "1 big Project Landingpage"],
            },
            {
                id: 2,
                title: "BOOTSTRAP",
                time: "2 buổi",
                lyThuyet: ["Cách sử dụng Boostrap 5", "Cách chia layout bằng BS5", "Cách sử dụng các component trong BS5"],
                baiTap: ["Chia layout với GRID", "List product"],
                toTal: ["5+ Mini Project", "1 big Project Landingpage"],
            },
            {
                id: 3,
                title: "SCSS",
                time: "3 buổi",
                lyThuyet: ["Cách cấu hình scss", "Cách viết scss", "Cách sử dụng variable", "Cách tạo mixin"],
                baiTap: ["List product", "Header", "Footer"],
                toTal: ["10+ Mini Project", "1 big Project Landingpage"],
            },
            {
                id: 4,
                title: "JAVASCRIPT CƠ BẢN",
                time: "15 buổi",
                lyThuyet: [
                    "Các cách khai báo biến, hoisting trong JS",
                    "Câu lệnh điều kiện IF/ELSE",
                    "FUNCTION và các loại FUNCTION",
                    "ARRAY và các phương thức trong ARRAY",
                    "OBJECT và các phương thức trong OBJECT",
                    "Các hàm xử lý thời gian",
                    "DOM VÀ EVENT",
                    "REGULAR EXPRESSION",
                ],
                baiTap: [
                    "20+ Bài tập xử lý IF/ELSE",
                    "10+ Bài tập xử lý FUNCTION",
                    "50+ Bài tập xử lý ARRAY",
                    "30+ Bài tập xử lý OBJECT",
                    "Dropdown",
                    "Darkmode",
                    "Password check",
                    "Game Oản tù tì",
                    "CountDown",
                    "Slide ảnh",
                    "Tab",
                ],
                toTal: ["Validate form", "Game tài xỉu", "Todolist", "CRUD Quản lý siêu thị"],
            },
            {
                id: 5,
                title: "JAVASCRIPT NÂNG CAO",
                time: "5 buổi",
                lyThuyet: ["Đồng bộ và bất đồng bộ", "Callback", "Promise", "Fetch API", "ASYNC/AWAIT", "RESTFUL API"],
                baiTap: ["Weather APP", "Dictionary APP", "Country APP", "Pokemon APP", "Meal APP", "LOGIN/REGISTER RESFUL API", "CRUD RESFULL API"],
                toTal: ["PROECT MOVIE"],
            },
            {
                id: 6,
                title: "FINNAL PROJECT",
                time: "5 buổi",
                lyThuyet: [
                    "Áp dụng kiến thức về SCSS để tổ chức CSS",
                    "Áp dụng kiến thức BOOTSTRAP để chia layout và responsive",
                    "Áp dụng kiến thức API để fetch api",
                    "Dùng JSON-SERVER để tạo RESFUL API",
                ],
                baiTap: [
                    "Xây dựng tính năng lọc, search sản phẩm",
                    "Xây dựng tính năng thêm sản phẩm vào giỏ hàng",
                    "Xây dựng tính năng đăng kí đăng nhập và phân quyền",
                    "Quản lý sản phẩm trong admin bao gồm thêm/xóa/sửa",
                    "Các tính năng liên quan",
                ],
                toTal: ["PROJECT THƯƠNG MẠI ĐIỆN TỬ + ADMIN QUẢN LÝ"],
            },
        ],
    },
    {
        id: 2,
        name: "REACT JS",
        desc: "Khóa học giúp bạn làm chủ thư viện js phổ biến nhất hiện nay cũng như thành thạo sử dụng các hook trong react",
        time: "30 buổi",
        price_offline: "9.500.000 VNĐ",
        price_online: "8.000.000 VNĐ",
        price_tragop: "3.600.000 VNĐ",
        img: course_2,
        timeline: [
            {
                id: 1,
                title: "React nền tảng",
                time: "3 buổi",
                lyThuyet: [
                    "Ôn tập các kiến thức về ES6",
                    "Làm quen với component",
                    "Phân biệt sự khác nhau các loại component",
                    "Kiến thức về props",
                    "Rendering list trong react",
                ],
                baiTap: ["List video youtube", "Tư duy tạo component"],
            },
            {
                id: 2,
                title: "Hook useState",
                time: "3 buổi",
                lyThuyet: [
                    "Hook trong react là gì",
                    "Mount, unmount component",
                    "Lifecycle trong react",
                    "Re Render trong component",
                    "Tác dụng của UseState",
                ],
                baiTap: ["Toggle button", "Change img", "Dropdown", "Tab", "Modal", "Slide", "Accordion", "Tab"],
                toTal: ["GAME CỜ CARO"],
            },
            {
                id: 3,
                title: "Styling trong react",
                time: "1 buổi",
                lyThuyet: ["Scss trong react", "Css module", "Styled component"],
                baiTap: ["Button", "List product"],
            },
            {
                id: 4,
                title: "React Bootstrap",
                time: "2 buổi",
                lyThuyet: ["Tích hợp react bootstrap", "Component trong react bootstrap", "Chia layout & responsive bằng react bootstrap"],
                baiTap: ["List product", "Header"],
                toTal: ["LANDINGPAGE"],
            },
            {
                id: 5,
                title: "TAILWIND CSS",
                time: "2 buổi",
                lyThuyet: ["Tích hợp Tailwind css", "Các class trong tailwind", "Component trong tailwind"],
                baiTap: ["List card", "Header"],
                toTal: ["LANDINGPAGE"],
            },
            {
                id: 6,
                title: "Hook useEffect",
                time: "3 buổi",
                lyThuyet: ["Định nghĩa useEffect", "Side Effect & clean up", "Call Api bằng useEffect", "Xử lý dom bằng useEffect"],
                baiTap: ["Đồng hồ", "API joke", "Img load more", "Pokemon"],
            },
            {
                id: 7,
                title: "React form",
                time: "2 buổi",
                lyThuyet: ["Xử lý form trong react", "Học kỹ thuật debouce", "Các dùng Formik để xử lý form"],
                baiTap: ["Validate form", "Auto email", "Hackernews"],
                toTal: ["TODOLIST"],
            },
            {
                id: 7,
                title: "useMemo, useCallback",
                time: "1 buổi",
                lyThuyet: ["Tìm hiểu hook memo và useMemo", "Tìm hiểu useCallback"],
                baiTap: ["Nhập dữ liệu hàng hóa"],
            },
            {
                id: 8,
                title: "Use Reducer",
                time: "1 buổi",
                lyThuyet: ["Tìm hiểu useReducer", "Quản lý state tập trung"],
                baiTap: ["Todolist"],
            },
            {
                id: 9,
                title: "Hook useContext",
                time: "2 buổi",
                lyThuyet: ["Tìm hiểu useContext", "Các quản lý state", "Truyền dữ liệu xuống các component"],
                baiTap: ["Darkmode", "Login"],
            },
            {
                id: 10,
                title: "React router",
                time: "3 buổi",
                lyThuyet: ["Cách định tuyến trong React", "Xử lý các vấn đề chuyển trang"],
                baiTap: ["Header menu"],
                toTal: ["MOVIE PAGE"],
            },
            {
                id: 11,
                title: "Xử lý giỏ hàng",
                time: "2 buổi",
                lyThuyet: ["Cách lọc sản phẩm", "Xử lý thêm sản phẩm vào giỏ", "Tăng giảm số lượng giỏ hàng", "Tích hợp thư viện toastify"],
                baiTap: ["Filter product", "Detail product", "Cart product"],
            },
            {
                id: 12,
                title: "Restful api",
                time: "1 buổi",
                lyThuyet: ["Tích hợp thư viện axios", "Tìm hiểu mockapi", "Các phương thức Get, Post, Put, Delete"],
                baiTap: ["Quản lý user - thêm ,xóa, sửa, cập nhật"],
            },
            {
                id: 13,
                title: "PROJECT FINAL",
                time: "4 buổi",
                lyThuyet: ["Cấu hình project", "Lên ý tưởng", "Xây dựng các component", "Xây dựng trang quản lý"],
                baiTap: [
                    "Tính tăng lọc search sản phẩm",
                    "Cấu hình react router",
                    "Quản lý state",
                    "Đăng nhập đăng ký",
                    "Tính năng giỏ hàng",
                    "Lưu đơn hàng vào dashboard",
                    "Gửi email",
                    "Public sản phẩm chạy thực tế",
                ],
                toTal: ["THUYẾT TRÌNH VÀ PHẢN BIỆN SẢN PHẨM"],
            },
        ],
    },
];
export default arrDataCourse;
